import ReactGA from 'react-ga4';
import config from './config.js';

class Analytics {
  constructor() {
    this.initialized = false;
    this.config = config.getGAConfig();
  }

  // Initialize Google Analytics
  initialize() {
    if (this.config.enabled && this.config.trackingId && !this.initialized) {
      ReactGA.initialize(this.config.trackingId, {
        debug: config.getCurrentEnvironment() === 'development',
        testMode: config.getCurrentEnvironment() === 'development'
      });
      
      this.initialized = true;
      console.log(`🔍 Google Analytics initialized with ID: ${this.config.trackingId}`);
    } else {
      console.log('📊 Google Analytics disabled or already initialized');
    }
  }

  // Track page views
  trackPageView(path, title) {
    if (this.initialized) {
      ReactGA.send({ 
        hitType: 'pageview', 
        page: path,
        title: title || document.title
      });
    }
  }

  // Track custom events
  trackEvent(action, category = 'User Interaction', label = '', value = 0) {
    if (this.initialized) {
      ReactGA.event({
        action,
        category,
        label,
        value
      });
    }
  }

  // Track form submissions
  trackFormSubmission(formName) {
    this.trackEvent('Form Submit', 'Forms', formName);
  }

  // Track button clicks
  trackButtonClick(buttonName) {
    this.trackEvent('Button Click', 'Navigation', buttonName);
  }

  // Track file downloads
  trackDownload(fileName) {
    this.trackEvent('File Download', 'Downloads', fileName);
  }
}

// Export singleton instance
const analytics = new Analytics();
export default analytics;